import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { apiFetch } from '../../api/core';
import { useEditItem2 } from '../../api/useNewItem';
import { useUser, login } from '../../userContext/UserContext';
import { useReturnUrl } from './useReturnUrl';

export const useLoginOtp = () => {
  const returnUrl = useReturnUrl();

  const userCtx = useUser();
  const history = useHistory();

  const data = useEditItem2<{ login: string, code: string, session_code: string, isCode: boolean }>({
    startWith: { login: "", code: "", session_code: "", isCode: false },
    dontResetOnSave: true,
    setToSaved: true,
    save: async (item) => {
      if(!item.isCode) {
        const result = await apiFetch<{ session_code: string }>("/api/login/otp/start", "post", { login: item.login }, { noAuth: true });
        return { ...item, session_code: result.session_code, isCode: true };
      } else {
        const result = await apiFetch<string>("/api/login/otp/complete", "post", { login: item.login, session_code: item.session_code, code: item.code }, { noAuth: true });
        login(userCtx, result);
        history.push(returnUrl.fromParam || "/");
        return item;
      }
    }
  })

  useEffect(() => {
    const loginFromUrl = new URLSearchParams(window.location.search).get("login");
    if(loginFromUrl) {
      data.update({ login: loginFromUrl });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ...data,
  }
}
